"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TreeStore = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _netUtils = require("@onviobr/net-utils");

var _bmTreeModel = require("./bm-tree-model");

var TreeStore = /*#__PURE__*/function () {
  function TreeStore() {
    var multipleSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _classCallCheck2.default)(this, TreeStore);
    this._store = void 0;
    this._multiSelect = void 0;
    this.emitter = void 0;
    this._store = [];
    this._multiSelect = multipleSelect;
    this.emitter = (0, _netUtils.eventEmitter)();
  }

  (0, _createClass2.default)(TreeStore, [{
    key: "get",
    value: function get(id) {
      var _this$_store$find, _context;

      return (_this$_store$find = (0, _find.default)(_context = this._store).call(_context, function (s) {
        return s.id === id;
      })) !== null && _this$_store$find !== void 0 ? _this$_store$find : null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._store;
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      var _context2, _context3;

      return (0, _map.default)(_context2 = (0, _filter.default)(_context3 = this._store).call(_context3, function (s) {
        return s.selected;
      })).call(_context2, function (s) {
        return s.details;
      });
    }
  }, {
    key: "getChecked",
    value: function getChecked() {
      var _context4, _context5;

      return (0, _map.default)(_context4 = (0, _filter.default)(_context5 = this._store).call(_context5, function (s) {
        return s.checked;
      })).call(_context4, function (s) {
        return s.details;
      });
    }
  }, {
    key: "setVisible",
    value: function setVisible(item) {
      var _context6,
          _this = this;

      var changed = [];
      changed.push(item.id);
      item.visible = true;
      var ancestors = (0, _filter.default)(_context6 = this._store).call(_context6, function (s) {
        var _context7;

        return (0, _includes.default)(_context7 = item.ancestors).call(_context7, s.id);
      });
      (0, _forEach.default)(ancestors).call(ancestors, function (a) {
        var _context8;

        changed.push(a.id);
        a.visible = true;
        a.expanded = true;
        var children = (0, _filter.default)(_context8 = _this._store).call(_context8, function (s) {
          var _context9;

          return (0, _includes.default)(_context9 = a.children).call(_context9, s.id);
        });
        (0, _forEach.default)(children).call(children, function (c) {
          changed.push(c.id);
          c.visible = true;
        });
      });
      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, changed);
    }
  }, {
    key: "setSelected",
    value: function setSelected(item, id, change) {
      var changed = [];

      if (change.selected !== undefined && !this._multiSelect) {
        var _context10;

        changed.push(id);
        (0, _forEach.default)(_context10 = this._store).call(_context10, function (s) {
          if (s.selected && s.id !== id) {
            changed.push(s.id);
          }

          s.selected = s.id === id ? Boolean(change.selected) : false;
        });

        if (!item.visible) {
          this.setVisible(item);
        }

        this.emitter.dispatchEvent(new CustomEvent(_bmTreeModel.TreeStateChangeType.Selected, {
          detail: changed
        }));
      } else if (change.selected !== undefined) {
        item.selected = change.selected;

        if (!item.visible) {
          this.setVisible(item);
        }
      }
    }
  }, {
    key: "setAncestorsCheckState",
    value: function setAncestorsCheckState(item, checked) {
      var _context11, _context13, _context14;

      var changed = [];
      (0, _forEach.default)(_context11 = this._store).call(_context11, function (d) {
        var _context12;

        if ((0, _includes.default)(_context12 = item.ancestors).call(_context12, d.id)) {
          changed.push(d.id);
          d.checked = checked;
        }
      });
      var checkedItems = (0, _filter.default)(_context13 = this._store).call(_context13, function (s) {
        return s.checked;
      });
      var checkedIds = (0, _map.default)(checkedItems).call(checkedItems, function (ci) {
        return ci.id;
      });
      (0, _forEach.default)(_context14 = this._store).call(_context14, function (s) {
        var _context15;

        var checkedDescendants = (0, _filter.default)(_context15 = s.descendants).call(_context15, function (d) {
          return (0, _includes.default)(checkedIds).call(checkedIds, d);
        });

        if (checkedDescendants && checkedDescendants.length > 0 && s.descendants.length > 0) {
          s.checked = checkedDescendants.length === s.descendants.length;
          s.indeterminate = checkedDescendants.length < s.descendants.length;
        } else if (s.descendants.length > 0) {
          s.indeterminate = false;
        }
      });
      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Checked, changed);
    }
  }, {
    key: "setDescendantsCheckState",
    value: function setDescendantsCheckState(item, checked) {
      var _context16,
          _this2 = this;

      var changed = [];
      (0, _forEach.default)(_context16 = item.descendants).call(_context16, function (d) {
        var _context17;

        var descendantState = (0, _find.default)(_context17 = _this2._store).call(_context17, function (s) {
          return s.id === d;
        });

        if (descendantState && descendantState.checked !== checked) {
          changed.push(descendantState.id);
          descendantState.checked = checked;
        }
      });
      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Checked, changed);
    }
  }, {
    key: "setDescendantsVisibleState",
    value: function setDescendantsVisibleState(item, expand) {
      var _this3 = this;

      var changed = [item.id];

      if (expand) {
        var _context18;

        (0, _forEach.default)(_context18 = item.children).call(_context18, function (c) {
          var _context19;

          var childState = (0, _find.default)(_context19 = _this3._store).call(_context19, function (cs) {
            return cs.id === c;
          });

          if (childState && !childState.visible) {
            changed.push(c);
            childState.visible = true;
            childState.checked = item.checked;
          }
        });
      } else {
        var _context20;

        (0, _forEach.default)(_context20 = item.descendants).call(_context20, function (d) {
          var _context21;

          var descendantState = (0, _find.default)(_context21 = _this3._store).call(_context21, function (s) {
            return s.id === d;
          });

          if (descendantState === null || descendantState === void 0 ? void 0 : descendantState.visible) {
            changed.push(d);
            descendantState.expanded = false;
            descendantState.checked = false;
            descendantState.selected = false;
            descendantState.indeterminate = false;
            descendantState.visible = false;
            item.indeterminate = false;
          }
        });
      }

      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, changed);
    }
  }, {
    key: "set",
    value: function set(itemRef, change) {
      var item;
      var id;

      if (typeof itemRef === 'string') {
        var _context22;

        item = (0, _find.default)(_context22 = this._store).call(_context22, function (s) {
          return s.id === itemRef;
        });
        id = itemRef;
      } else {
        var _context23;

        item = (0, _find.default)(_context23 = this._store).call(_context23, function (s) {
          return s.details === itemRef;
        });
        id = item ? item.id : '';
      }

      if (item) {
        var _change$expanded;

        if (change.selected && change.selected !== item.selected) {
          this.setSelected(item, id, change);
        } else if (change.selected === false) {
          item.selected = false;
          this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, [item.id]);
        }

        if (change.indeterminate || change.indeterminate !== undefined) {
          item.indeterminate = change.indeterminate;
        } else {
          item.indeterminate = false;
        }

        item.expanded = change.expanded === undefined && !change.selected ? item.expanded : Boolean((_change$expanded = change.expanded) !== null && _change$expanded !== void 0 ? _change$expanded : change.selected);
        item.checked = change.checked === undefined ? item.checked : change.checked;

        if (change.visible !== undefined) {
          this.setVisible(item);
        }

        if (change.checked !== undefined && item.descendants && item.descendants.length > 0) {
          this.setDescendantsCheckState(item, change.checked);
        }

        if (change.checked !== undefined && item.ancestors && item.ancestors.length > 0) {
          this.setAncestorsCheckState(item, change.checked);
        }

        if ((change.expanded !== undefined || change.selected) && item.descendants && item.descendants.length > 0) {
          var _change$expanded2;

          this.setDescendantsVisibleState(item, Boolean((_change$expanded2 = change.expanded) !== null && _change$expanded2 !== void 0 ? _change$expanded2 : change.selected));
        }

        return true;
      }

      return false;
    }
  }, {
    key: "setAll",
    value: function setAll(change) {
      var changed = [];

      if (change.visible !== undefined) {
        var _context24;

        (0, _forEach.default)(_context24 = this._store).call(_context24, function (s) {
          changed.push(s.id);

          if (change.visible) {
            s.visible = true;
            s.expanded = true;
          } else if (!change.visible) {
            s.visible = s.layer === 0;
            s.expanded = false;
            s.selected = s.layer === 0 ? s.selected : false;
          }
        });
        this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, changed);
      }
    }
  }, {
    key: "setPersistedStateItems",
    value: function setPersistedStateItems(t, oldStore, parent) {
      var _parentOldStateItem;

      var oldStoreItem = oldStore ? (0, _find.default)(oldStore).call(oldStore, function (o) {
        return o.id === t.id;
      }) : null;
      var subItems;
      var subItemsChecked;
      var parentOldStateItem;

      if (oldStore) {
        subItems = (0, _filter.default)(oldStore).call(oldStore, function (o) {
          var _context25, _context26;

          return t.subItems ? (0, _includes.default)(_context25 = (0, _map.default)(_context26 = t.subItems).call(_context26, function (s) {
            return s.id;
          })).call(_context25, o.id) : false;
        });
        subItemsChecked = (0, _filter.default)(subItems).call(subItems, function (s) {
          return s.checked;
        });
        parentOldStateItem = parent ? (0, _find.default)(oldStore).call(oldStore, function (o) {
          return o.id === parent.id;
        }) : null;
      }

      var thereAreCheckedSubItems = subItems && subItemsChecked && subItems.length > 0 && subItemsChecked.length === subItems.length;
      var checked = oldStore ? Boolean((oldStoreItem === null || oldStoreItem === void 0 ? void 0 : oldStoreItem.checked) || thereAreCheckedSubItems || ((_parentOldStateItem = parentOldStateItem) === null || _parentOldStateItem === void 0 ? void 0 : _parentOldStateItem.checked)) : Boolean(t.checked);
      var selected = oldStoreItem ? oldStoreItem.selected : Boolean(t.selected);
      var indeterminate = oldStoreItem ? Boolean(oldStoreItem.indeterminate && subItems && subItemsChecked && subItemsChecked.length < subItems.length) : false;
      var visible = oldStoreItem && parent ? Boolean(oldStoreItem.visible && parent.expanded) : !parent || Boolean(t.selected) || parent.expanded;
      var expanded = oldStoreItem ? Boolean(oldStoreItem.expanded && t.subItems && t.subItems.length) : false;
      return {
        checked: checked,
        selected: selected,
        indeterminate: indeterminate,
        visible: visible,
        expanded: expanded
      };
    }
  }, {
    key: "setStore",
    value: function setStore(tree, parent, totalSelected, oldStore) {
      var _this4 = this,
          _context33;

      if (!oldStore) {
        var _context27;

        oldStore = (0, _slice.default)(_context27 = this._store).call(_context27, 0);
        this._store = [];
      }

      var treeIds = [];
      (0, _forEach.default)(tree).call(tree, function (t, i) {
        var _context28, _context29, _totalSelected;

        treeIds.push(t.id);

        if (parent) {
          parent.descendants.push(t.id);
          parent.children.push(t.id);
        }

        var ancestors = (0, _concat.default)(_context28 = []).call(_context28, (0, _toConsumableArray2.default)(parent ? parent.ancestors : []), (0, _toConsumableArray2.default)(parent ? [parent.id] : []));

        var _this4$setPersistedSt = _this4.setPersistedStateItems(t, oldStore, parent),
            checked = _this4$setPersistedSt.checked,
            selected = _this4$setPersistedSt.selected,
            indeterminate = _this4$setPersistedSt.indeterminate,
            visible = _this4$setPersistedSt.visible,
            expanded = _this4$setPersistedSt.expanded;

        var stateItem = {
          id: t.id,
          name: t.name,
          dataQeId: t.dataQeId,
          parentId: parent ? parent.id : 'root',
          ancestors: ancestors,
          descendants: [],
          children: [],
          checked: checked,
          selected: selected,
          indeterminate: indeterminate,
          visible: visible,
          expanded: expanded,
          layer: ancestors.length,
          index: i,
          allowSelect: t.allowSelect,
          leftIcon: t.leftIcon,
          rightIcon: t.rightIcon,
          href: t.href,
          showCheckBox: t.showCheckBox,
          details: t
        };
        totalSelected = t.selected ? (0, _concat.default)(_context29 = []).call(_context29, (0, _toConsumableArray2.default)((_totalSelected = totalSelected) !== null && _totalSelected !== void 0 ? _totalSelected : []), [stateItem]) : totalSelected;

        _this4._store.push(stateItem);

        if (t.selected) {
          _this4.setVisible(stateItem);
        }

        if (t.subItems) {
          var res = _this4.setStore(t.subItems, stateItem, totalSelected, oldStore);

          totalSelected = res;
        }
      });

      if (totalSelected && totalSelected.length > 0) {
        (0, _forEach.default)(totalSelected).call(totalSelected, function (s) {
          _this4.setVisible(s);
        });
      }

      if (parent) {
        var _context30;

        var ancest = (0, _filter.default)(_context30 = this._store).call(_context30, function (s) {
          var _context31;

          return (0, _includes.default)(_context31 = parent.ancestors).call(_context31, s.id);
        });
        (0, _forEach.default)(ancest).call(ancest, function (p) {
          var _context32;

          p.descendants = (0, _concat.default)(_context32 = []).call(_context32, (0, _toConsumableArray2.default)(p.descendants), treeIds);
        });
      }

      this.emitter.emit(_bmTreeModel.TreeStateChangeType.Visible, (0, _map.default)(_context33 = this._store).call(_context33, function (s) {
        return s.id;
      }));
      return totalSelected;
    }
  }]);
  return TreeStore;
}();

exports.TreeStore = TreeStore;
